'use client';
import { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import React from 'react';
import {
   Box,
   Checkbox,
   Drawer,
   DrawerBody,
   DrawerCloseButton,
   DrawerContent,
   DrawerHeader,
   DrawerOverlay,
   Flex,
   Input,
   InputGroup,
   Text,
   useColorMode,
   useColorModeValue,
   useDisclosure,
} from '@chakra-ui/react';
import Select from 'react-select';
import Card from 'components/card/Card';
import { GridItem } from '@chakra-ui/react';
import nodata from 'assets/img/nfts/no data.svg';
import { Button, Image, Grid } from '@chakra-ui/react';
import Download from '../../../../assets/img/nfts/download.svg';
import xls from '../../../../../src/assets/img/nfts/xls.svg';
import json from '../../../../../src/assets/img/nfts/json.svg';
import back from '../../../../../src/assets/img/nfts/back.svg';
import ViewSingleCashBankData from 'components/UIcomponents/ViewSingleCashBankData';
import SalesDetails from 'components/salesDetails/SalesDetails';
import { deleteSaleInvoice, getSaleInvoice } from '../../../../redux/actions/salesInvoice';
import { deletePurchaseInvoice, getPurchaseInvoice } from '../../../../redux/actions/purchaseInvoice';
import { getReceiveInventory } from '../../../../redux/actions/receiveInventory';
import { getIssueInventory } from '../../../../redux/actions/issueInventory';
import { getAccountById } from '../../../../redux/actions/account';
import StatementFilter from '../components/StatementFilter';
import { IoFilterOutline } from 'react-icons/io5';
import {
   deletePurchaseReturnInvoice,
   getSinglePurchaseReturn,
   getSinglePurchaseReturnWithPrevAndNext,
} from '../../../../redux/actions/purchaseReturnInvoice';
import {
   deleteSaleReturnInvoice,
   getSingleSalesReturnWithPrevAndNext,
} from '../../../../redux/actions/salesReturnInvoice';
import { deleteRecord } from 'utils/util';
import { getOneVoucher } from '../../../../redux/actions/voucher';
import { Popover, PopoverTrigger, PopoverContent, PopoverBody } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { clearCacheReport, getSatementReport, statementCheckedStyle } from '../../../../redux/actions/reports';
import { getAccountForReport } from '../../../../redux/actions/account';
import { useGlobal, useUser } from '../../../../contexts';
import { ChevronDownIcon, ChevronUpIcon, SearchIcon } from '@chakra-ui/icons';
import { getShareCompanyOptions } from 'utils/util';
import DotIcon from '../../../../assets/img/nfts/dot.svg';
import { renderDynamicDropdown } from 'components/ui/DynamicDropdown';
import { LuRefreshCcw } from 'react-icons/lu';
import PeriodDatePicker from 'components/RangePicker/PeriodDatePicker';
import { motion } from 'framer-motion';
import * as XLSX from 'xlsx-js-style';
import 'jspdf-autotable';
import JournalVoucherForm from 'views/admin/journal-vouchers/Pages/JournalVoucherForm';
import { getJournalVoucher } from '../../../../redux/actions/journalVoucher';
import { jsPDF } from 'jspdf';
import PaymentcaseFormEdit from '../../cash/PaymentcaseFormEdit';
import * as Yup from 'yup';
import { getDaybookForPayments } from '../../../../redux/actions/daybook';
import { deleteRecordForSales } from 'utils/util';
import Loader from 'views/admin/default/Loader';
import DeletePasswordModal from 'views/admin/sales/Pages/SalesInvoiceMaster/DeletePasswordModal';
import { VariableSizeList } from 'react-window';

const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);

// ─────────────────────────────────────────────────────────────────────────────
// PERMANENT ALIGNMENT FIX: CSS Grid column template
// All rows (header + data) share EXACTLY the same template → perfect alignment forever.
// minmax(min, max) → column shrinks/grows with content but never overflows.
// "1fr" on Particulars → takes remaining space naturally.
// ─────────────────────────────────────────────────────────────────────────────
const GRID_COLS = [
   '44px',        // Checkbox
   '100px',       // Date
   '90px',        // Doc#
   'minmax(120px, 1.2fr)', // Daybook
   'minmax(120px, 1.2fr)', // Contra Account
   'minmax(140px, 2fr)',   // Particulars (flexible — takes most space)
   'minmax(90px, 1fr)',    // Debit
   'minmax(90px, 1fr)',    // Credit
   'minmax(110px, 1fr)',   // Balance
];
const GRID_TEMPLATE = GRID_COLS.join(' ');

// Shared cell base style
const cellBase = {
   display: 'flex',
   alignItems: 'center',
   padding: '0 8px',
   overflow: 'hidden',
   fontSize: '12px',
};

const cellRight = {
   ...cellBase,
   justifyContent: 'flex-end',
};

const MemoizedDataRow = React.memo(
   ({
      row,
      idx,
      rowId,
      isSelected,
      onSelection,
      onRowClick,
      formatDateToDDMMYYYY,
      iconColor,
      formatCellAmount,
      localStyleUpdates,
      isDark,
   }) => {
      const isOddRow = idx % 2 !== 0;

      const absBal = Math.abs(row.bal ?? 0);
      const formattedVal = absBal.toLocaleString('en-IN', {
         minimumFractionDigits: 2,
         maximumFractionDigits: 2,
      });
      const [intPart, decimalPart] = formattedVal.split('.');

      const localStyleKey = `${row.DocType}-${row.docid}`;
      const effectiveCheckedStyle =
         localStyleUpdates[localStyleKey] !== undefined
            ? localStyleUpdates[localStyleKey]
            : row.checkedStyle;

      // Row background based on checkedStyle
      let rowBg, rowBorderColor, rowTextColor;
      if (effectiveCheckedStyle === 1) {
         rowBg = 'rgba(16,185,129,0.12)';
         rowBorderColor = '#10b981';
         rowTextColor = isDark ? '#34d399' : '#065f46';
      } else if (effectiveCheckedStyle === 2) {
         rowBg = 'rgba(239,68,68,0.12)';
         rowBorderColor = '#ef4444';
         rowTextColor = isDark ? '#f87171' : '#991b1b';
      } else {
         rowBg = isOddRow
            ? isDark ? 'rgba(0,63,140,0.08)' : 'rgba(0,63,140,0.04)'
            : 'transparent';
         rowBorderColor = '#60a5fa';
         rowTextColor = iconColor;
      }

      return (
         <div
            onClick={(e) => onRowClick(row, e)}
            style={{
               display: 'grid',
               gridTemplateColumns: GRID_TEMPLATE,
               alignItems: 'center',
               minHeight: '29px',
               background: rowBg,
               borderLeft: `3px solid ${rowBorderColor}`,
               cursor: 'pointer',
               color: rowTextColor,
               transition: 'background 0.15s',
            }}
            onMouseEnter={(e) => {
               e.currentTarget.style.background =
                  effectiveCheckedStyle === 1
                     ? 'rgba(16,185,129,0.18)'
                     : effectiveCheckedStyle === 2
                        ? 'rgba(239,68,68,0.18)'
                        : isDark ? 'rgba(0,63,140,0.14)' : 'rgba(0,63,140,0.08)';
            }}
            onMouseLeave={(e) => {
               e.currentTarget.style.background = rowBg;
            }}>

            {/* Checkbox */}
            <div style={{ ...cellBase, justifyContent: 'center' }}
               onClick={(e) => e.stopPropagation()}>
               <Checkbox
                  isChecked={isSelected}
                  onChange={(e) => {
                     e.stopPropagation();
                     onSelection(rowId, e.target.checked, row);
                  }}
                  colorScheme="blue"
                  size="md"
               />
            </div>

            {/* Date */}
            <div style={{ ...cellBase, whiteSpace: 'nowrap', fontSize: '14px', paddingBottom: '4px' }} >
               {row.date ? formatDateToDDMMYYYY(row.date) : '-'}
            </div>

            {/* Doc# */}
            <div style={{ ...cellBase, whiteSpace: 'nowrap', fontSize: '14px' }}>
               {row.prefix}{row.docnumber}{row.postFix}
            </div>

            {/* Daybook */}
            <div style={{
               ...cellBase,
               whiteSpace: 'nowrap',
               overflow: 'hidden',
               textOverflow: 'ellipsis',
               fontSize: '14px'
            }}>
               <span title={row.daybookname || '-'} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block', width: '100%' }}>
                  {row.daybookname || '-'}
               </span>
            </div>

            {/* Contra Account */}
            <div style={{
               ...cellBase,
               overflow: 'hidden',
               fontSize: '14px'
            }}>
               <span title={row.finalcontraaccountname || '-'} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block', width: '100%' }}>
                  {row.finalcontraaccountname || '-'}
               </span>
            </div>

            {/* Particulars */}
            <div style={{ ...cellBase, overflow: 'hidden', fontSize: '14px' }}>
               <span title={row.particulars || '-'} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block', width: '100%' }}>
                  {row.particulars || '-'}
               </span>
            </div>

            {/* Debit */}
            <div style={{ ...cellRight, whiteSpace: 'nowrap', fontSize: '14px' }}>
               {row.txnType === 1 ? formatCellAmount(row.amount) : '-'}
            </div>

            {/* Credit */}
            <div style={{ ...cellRight, whiteSpace: 'nowrap', fontSize: '14px' }}>
               {row.txnType === 0 ? formatCellAmount(row.amount) : '-'}
            </div>

            {/* Balance */}
            <div style={{ ...cellRight, whiteSpace: 'nowrap', gap: '1px', fontSize: '14px' }}>
               {row.bal === undefined || row.bal === null ? '-' : (
                  <>
                     <span>{intPart}</span>
                     <span style={{ fontSize: '10px', marginTop: '1px' }}>.{decimalPart}</span>
                     <span style={{ fontSize: '10px', marginLeft: '2px' }}>
                        {row.bal < 0 ? 'DB' : 'CR'}
                     </span>
                  </>
               )}
            </div>
         </div>
      );
   },
   (prev, next) =>
      prev.isSelected === next.isSelected &&
      prev.row.checkedStyle === next.row.checkedStyle &&
      prev.row.bal === next.row.bal,
);

const Ledger = () => {
   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const backgroundColor = useColorModeValue('white', '#101F4A');
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const iconColor = useColorModeValue('#000000', '#ffffff');
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const [flattenedData, setFlattenedData] = useState([]);
   const [containerHeight, setContainerHeight] = useState(700);
   const listRef = useRef(null);

   const { companyList, userGlobalSettingsData, company } = useGlobal();
   const accounts = useSelector((state) => state.account.listForReport || []);
   const rawLedger = useSelector((state) => state.reports.statement || []);
   const dispatch = useDispatch();
   const { user } = useUser();
   const admin = user?.isAdmin;
   const rights = user?.userRights?.find((ur) => ur?.companyId === user?.loginhistory?.companyId);
   const dbName = company?.dbName;

   const abortControllerRef = useRef(null);
   const searchTimeoutRef = useRef(null);
   const wrapperRef = useRef();
   const initialLoadRef = useRef(false);
   const previousParamsRef = useRef({});

   const [localStyleUpdates, setLocalStyleUpdates] = useState({});
   const [selectedRows, setSelectedRows] = useState({});
   const [selectedRowData, setSelectedRowData] = useState([]);
   const [isAllSelected, setIsAllSelected] = useState(false);
   const [activeFilter, setActiveFilter] = useState('all');
   const [entityType, setEntityType] = useState([]);
   const [entityTypesv, setEntityTypesv] = useState([]);
   const [isEditFormOpen, setIsEditFormOpen] = React.useState(false);
   const [isBankPageTrue, setIsBankPageTrue] = React.useState(false);
   const [isOpenSingleViewinr, setIsOpenSingleViewinr] = React.useState(null);
   const [isOpenSingleViewcnb, setIsOpenSingleViewcnb] = React.useState(null);
   const [dynamicUserDetails, setDynamicUserDetails] = useState([]);
   const [isModalLoading, setIsModalLoading] = useState(false);
   const [isOpenPurchaseReturnSingleView, setIsOpenPurchaseReturnSingleView] = React.useState(null);
   const { isOpen: isFilterOpen, onOpen: onFilterOpen, onClose: onFilterClose } = useDisclosure();

   const singleEntity = useSelector((state) => {
      if (entityType === 'receivemaster') return state?.receiveInventory?.single || {};
      else if (entityType === 'issuemaster') return state?.issueInventory?.single || {};
      else if (entityType === 'cash') return state.voucher?.single || {};
      else if (entityType === 'bank') return state.voucher?.single || {};
      else return {};
   });

   const validationSchema = Yup.object().shape({
      daybookId: Yup.number().required('Daybook is required'),
      accountId: Yup.number().typeError('Account must be a valid').required('Account is required').min(1, 'Account must be greater than 0'),
      amount: Yup.number().required('Amount is required').min(0, 'Amount cannot be negative'),
      docNumber: Yup.string().required('Document number is required'),
      txnDate: Yup.date().required('Transaction date is required').typeError('Invalid transaction date'),
      txnType: Yup.number().required('Transaction type is required'),
   });

   const accountData = useSelector((state) => state.account.list);
   const shouldSendIdInDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook || false;
   const daybookTypeData = useSelector((state) => state.daybook?.listPayment || null);
   const [transactionType, setTransactionType] = useState('payment');
   const [receivedAmount, setReceivedAmount] = useState(0);
   const [totalPendingAccount, setTotalPendingAccount] = useState(0);
   const [updateFormLoading, setUpdateFormLoading] = useState(false);
   const [isOutstandingModalOpen, setIsOutstandingModalOpen] = useState(false);
   const [selectedEditAccount, setSelectedEditAccount] = useState(null);
   const [pendingVoucher, setPendingVoucher] = useState([]);
   const [errors, setErrors] = useState({});
   const [sorting, setSorting] = useState([]);
   const [dataId, setDataId] = useState(null);
   const [isModalOpen, setIsModalOpen] = useState(false);
   const daybookData = useSelector((state) => state.daybook?.list || []);

   const [formData, setFormData] = useState({
      companyId: parseInt(localStorage.getItem('companyId')),
      daybookId: null, docNumber: 0,
      txnType: `${transactionType === 'payment' ? 1 : 0}`,
      txnDate: new Date().toISOString().split('T')[0],
      accountId: null, amount: receivedAmount ? receivedAmount : 0,
      brokerId: null, supplierId: null, chequeNo: 0, transactionNo: null,
      bankId: null, bankBranchId: null, particulars: '', depositeDate: null,
      clearingDate: null, tdsApplicable: false, tdsAccountId: null, tdsLimit: 0,
      tdsRate: 0, tdsCess: 0, tdsSurcharge: 0, tdsAmount: 0, tdsCessAmount: 0,
      tdsSurchargeAmount: 0, tdsHCessAmount: 0, tdsInterestAmount: 0,
      tdsPenaltyAmount: 0, tdsOthersAmount: 0, notes1: '', notes2: '', notes3: '',
      notes4: '', notes5: '', userNote: '', taxableValue: '', GSTAmount: 0,
      stateOfSupply: 0, isRCM: false, GSTSubTxnType: 0, HSNSACId: null,
      typeofSupply: 0, partyBillNo: 0, GSTTxnType: 0,
      chequeDate: new Date().toISOString().split('T')[0], outAdjustments: [],
   });

   const [currentRow, setCurrentRow] = useState(null);
   const [isEditMode, setIsEditMode] = useState(true);
   const [isOpenJV, setisOpenJV] = React.useState(null);

   const globalSetting = userGlobalSettingsData?.[0]?.askCompany?.account;
   const shouldShowCompanyDropdown = globalSetting || false;
   const companyId = Number(localStorage.getItem('companyId'));
   const userRights = user?.user?.userRights || user?.userRights;

   const cashReceiveRight = Array.isArray(user?.userRights) ? user.userRights.find((r) => r.companyId === companyId)?.cashReceive : null;
   const cashPaymentRight = Array.isArray(user?.userRights) ? user.userRights.find((r) => r.companyId === companyId)?.cashPayment : null;
   const bankReceiveRight = Array.isArray(user?.userRights) ? user.userRights.find((r) => r.companyId === companyId)?.bankReceive : null;
   const bankPaymentRight = Array.isArray(user?.userRights) ? user.userRights.find((r) => r.companyId === companyId)?.bankPayment : null;
   const saleInvoiceRight = Array.isArray(userRights) ? userRights.find((r) => r.companyId === companyId)?.saleinvoice : null;
   const saleReturnRight = Array.isArray(userRights) ? userRights.find((r) => r.companyId === companyId)?.salereturn : null;
   const purchaseInvoiceRight = Array.isArray(userRights) ? userRights.find((r) => r.companyId === companyId)?.purchaseinvoice : null;
   const purchaseReturnRight = Array.isArray(userRights) ? userRights.find((r) => r.companyId === companyId)?.purchasereturn : null;

   const account = useSelector((state) => state.account.single);
   const viewDatapr = useSelector((state) => state.purchaseReturnInvoice?.purchaseReturnData);
   const viewDatasr = useSelector((state) => state.salesReturnInvoice?.saleReturnData);
   const viewDatasi = useSelector((state) => state.sales?.single);
   const viewDatapi = useSelector((state) => state?.purchaseInvoice?.single);

   const { viewDetail, paginate } = useMemo(() => {
      const data =
         entityType === 'purchasereturn' ? viewDatapr?.data[0]
            : entityType === 'salereturn' ? viewDatasr?.data[0]
               : entityType === 'saleinvoice' ? viewDatasi
                  : entityType === 'purchaseinvoice' ? viewDatapi : null;
      const pagination =
         entityType === 'purchasereturn' ? viewDatapr?.pagination
            : entityType === 'salereturn' ? viewDatasr?.pagination
               : entityType === 'saleinvoice' ? viewDatasi?.pagination
                  : entityType === 'purchaseinvoice' ? viewDatapi?.pagination : null;
      return { viewDetail: data, paginate: pagination };
   }, [entityType, viewDatapr, viewDatasr, viewDatasi, viewDatapi]);

   const [companyFilter, setCompanyFilter] = useState([]);
   const [searchInput, setSearchInput] = useState('');
   const [searchQuery, setSearchQuery] = useState('');
   const [accountId, setAccountId] = useState(null);
   const [dateRange, setDateRange] = useState(() => {
      const today = new Date();
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(today.getDate() - 6);
      return {
         fromDate: sevenDaysAgo.toISOString().split('T')[0],
         toDate: today.toISOString().split('T')[0],
      };
   });

   const [isLoading, setIsLoading] = useState(false);
   const [isFilterLoading, setIsFilterLoading] = useState(false);
   const isFirstRender = useRef(true);
   const [expanded, setExpanded] = useState(false);
   const [expandedItems, setExpandedItems] = useState({});
   // React state for dropdown — works inside VariableSizeList (CSS group-hover does not)
   const [filterDropdownOpen, setFilterDropdownOpen] = useState(false);
   const dropdownRef = useRef(null);
   const { isOpen, onOpen, onClose } = useDisclosure();

   // Close filter dropdown when clicking outside
   useEffect(() => {
      const handleClickOutside = (e) => {
         if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
            setFilterDropdownOpen(false);
         }
      };
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
   }, []);

   useEffect(() => {
      if (isFirstRender.current) {
         isFirstRender.current = false;
         return;
      }
      setIsFilterLoading(false);
   }, [rawLedger]);

   useEffect(() => {
      if (rawLedger && rawLedger.length > 0) {
         const initialExpandedState = {};
         rawLedger.forEach((company) => {
            initialExpandedState[`company-${company.companyId}`] = true;
            company.accounts?.forEach((acc) => {
               initialExpandedState[`account-${acc.accountId}`] = true;
            });
         });
         setExpandedItems(initialExpandedState);
      }
   }, [rawLedger]);

   useEffect(() => {
      if (accountId !== null) localStorage.setItem('ledgerSelectedAccountId', accountId.toString());
      else localStorage.removeItem('ledgerSelectedAccountId');
   }, [accountId]);

   const formatCellAmount = useCallback((amount) => {
      const formatted = Math.abs(amount).toLocaleString('en-IN', {
         minimumFractionDigits: 2,
         maximumFractionDigits: 2,
      });
      const [integerPart, decimalPart] = formatted.split('.');
      return (
         <>
            {integerPart}
            <Text as="span" fontSize="10px">.{decimalPart}</Text>
         </>
      );
   }, []);

   const companyOptions = useMemo(() => getShareCompanyOptions({ dbName, company: companyList }), [companyList, dbName]);

   const lastcompanyOptions = useMemo(() => {
      const currentUserCode = user?.loginhistory?.code;
      const currentCompanyId = user?.loginhistory?.companyId;

      // SHARED COMPANY MODE: When code is present
      if (currentUserCode) {
         // Find the company with matching ID AND matching dbName
         const sharedCompany = companyList.find(
            company => company.id === currentCompanyId && company.dbName === currentUserCode
         );

         if (sharedCompany) {
            return [{
               value: sharedCompany.id,
               label: sharedCompany.name,
               id: sharedCompany.id,
               name: sharedCompany.name,
            }];
         }

         // Fallback: try to find by dbName only
         const companiesWithDbName = companyList.filter(company => company.dbName === currentUserCode);
         if (companiesWithDbName.length > 0) {
            return companiesWithDbName.map(company => ({
               value: company.id,
               label: company.name,
               id: company.id,
               name: company.name,
            }));
         }

         return [];
      }

      // NORMAL MODE: When no code, show companies without dbName
      return companyList
         .filter(company => !company.dbName)
         .map(company => ({
            value: company.id,
            label: company.name,
            id: company.id,
            name: company.name,
         }));
   }, [companyList, user?.loginhistory?.code, user?.loginhistory?.companyId]);

   const accountOptions = useMemo(() =>
      accounts.map((acc) => ({ ...acc, value: acc.id, label: acc.name })),
      [accounts]);

   const companyIds = useMemo(() =>
      companyFilter.length > 0
         ? companyFilter
         : localStorage.getItem('companyId')
            ? [parseInt(localStorage.getItem('companyId'))]
            : [],
      [companyFilter]);

   const processedLedger = useMemo(() =>
      rawLedger.map((company) => ({
         ...company,
         accounts: company.accounts
            ? Object.keys(company.accounts).map((accId) => {
               const acc = company.accounts[accId];
               return { ...acc, data: Array.isArray(acc.data) ? acc.data.slice().reverse() : [] };
            })
            : [],
      })),
      [rawLedger]);

   const getAllRows = useCallback(() => {
      const allRows = [];
      processedLedger.forEach((company) => {
         company.accounts?.forEach((acc) => {
            acc.data?.forEach((row, idx) => {
               allRows.push({ rowId: `${acc.accountId}-${idx}`, row, accountId: acc.accountId });
            });
         });
      });
      return allRows;
   }, [processedLedger]);

   const getFilteredRows = useCallback((mode) => {
      const allRows = getAllRows();
      switch (mode) {
         case 'checked': return allRows.filter(({ row }) => row.checkedStyle === 1);
         case 'problem': return allRows.filter(({ row }) => row.checkedStyle === 2);
         case 'unchecked': return allRows.filter(({ row }) => !row.checkedStyle || row.checkedStyle === 0);
         default: return allRows;
      }
   }, [getAllRows]);

   const getStatusCounts = useCallback(() => {
      const allRows = getAllRows();
      return {
         all: allRows.length,
         checked: allRows.filter(({ row }) => row.checkedStyle === 1).length,
         problem: allRows.filter(({ row }) => row.checkedStyle === 2).length,
         unchecked: allRows.filter(({ row }) => !row.checkedStyle || row.checkedStyle === 0).length,
      };
   }, [getAllRows]);

   const statusCounts = getStatusCounts();

   const fetchData = useCallback(async (searchQuery = '') => {
      const hasValidCompanyIds = Array.isArray(companyIds) && companyIds.length > 0 && !companyIds.some((id) => isNaN(Number(id)) || Number(id) <= 0);
      const hasValidAccountId = accountId && !isNaN(Number(accountId)) && Number(accountId) > 0;
      const hasValidDateRange = dateRange.fromDate && dateRange.toDate;

      // ── If no account selected, clear data and show empty state ──
      if (!hasValidAccountId) {
         setFlattenedData([]);
         return;
      }

      if (!hasValidCompanyIds || !hasValidDateRange) return;

      const currentParams = { companyIds: companyIds.join(','), accountId, fromDate: dateRange.fromDate, toDate: dateRange.toDate, searchQuery };
      const previousParams = previousParamsRef.current;
      if (initialLoadRef.current && JSON.stringify(previousParams) === JSON.stringify(currentParams)) return;

      if (abortControllerRef.current) abortControllerRef.current.abort();
      abortControllerRef.current = new AbortController();
      setIsLoading(true);

      try {
         const validCompanyIds = companyIds.filter((id) => !isNaN(Number(id)) && Number(id) > 0);
         await dispatch(getSatementReport({
            fromDate: dateRange.fromDate, toDate: dateRange.toDate,
            companyIds: validCompanyIds.join(','), accIds: accountId,
            orderBy: 'desc', search: searchQuery,
         }));
         previousParamsRef.current = currentParams;
         initialLoadRef.current = true;
      } catch (error) {
         if (error.name !== 'AbortError') console.error('Error fetching ledger:', error);
      } finally {
         setIsLoading(false);
         setIsFilterLoading(false);
         abortControllerRef.current = null;
      }
   }, [dispatch, companyIds, accountId, dateRange]);

   const validCompanyIds = companyIds.filter((id) => !isNaN(Number(id)) && Number(id) > 0);

   useEffect(() => {
      const hasValid = Array.isArray(companyIds) && companyIds.length > 0 && !companyIds.some((id) => isNaN(Number(id)) || Number(id) <= 0);
      if (!hasValid) return;
      const validIds = companyIds.filter((id) => !isNaN(Number(id)) && Number(id) > 0);
      dispatch(clearCacheReport());
      dispatch(getAccountForReport({
         compId: user?.loginhistory?.companyId, status: true,
         ...(shouldShowCompanyDropdown && { companyIds: validIds.join(',') }),
      }));
   }, [dispatch, user, companyIds, shouldShowCompanyDropdown]);

   useEffect(() => {
      const timer = setTimeout(() => fetchData(), 500);
      return () => { clearTimeout(timer); if (abortControllerRef.current) abortControllerRef.current.abort(); };
   }, [fetchData]);

   useEffect(() => {
      const hasValid = Array.isArray(companyIds) && companyIds.length > 0 && accountId && dateRange.fromDate && dateRange.toDate;
      if (!hasValid) return;
      const timer = setTimeout(() => fetchData(''), 100);
      return () => clearTimeout(timer);
   }, [companyIds, accountId, dateRange.fromDate, dateRange.toDate]);

   const storedCompanyId = localStorage.getItem('companyId');
   useEffect(() => {
      if (storedCompanyId && companyList?.length > 0 && !initialLoadRef.current) {
         const id = parseInt(storedCompanyId);
         const match = companyList?.find((c) => c.id === id);
         if (match) setCompanyFilter([match.id]);
      }
   }, [companyList, storedCompanyId]);

   useEffect(() => {
      const handleKeyDown = (e) => { if (e.altKey) { e.preventDefault(); e.stopPropagation(); } };
      document.addEventListener('keydown', handleKeyDown, { capture: true });
      return () => document.removeEventListener('keydown', handleKeyDown, { capture: true });
   }, []);

   const handleDateRangeChange = useCallback((dates) => {
      if (!dates || dates.length !== 2) return;
      const [from, to] = dates.map((date) => {
         if (!date) return '';
         const d = new Date(date);
         if (isNaN(d.getTime())) return '';
         return d.toISOString().split('T')[0];
      });
      setDateRange({ fromDate: from || dateRange.fromDate, toDate: to || dateRange.toDate });
   }, [dateRange]);

   const handleCompanyChange = useCallback((sel) => setCompanyFilter(sel ? sel : []), []);

   // ── KEY FIX: When account is cleared, immediately wipe all ledger data ──
   const handleAccountChange = useCallback((sel) => {
      const newAccountId = sel ? sel.value : null;
      setAccountId(newAccountId);

      if (!newAccountId) {
         // Clear Redux ledger data so old account data doesn't remain visible
         dispatch(clearCacheReport());
         // Reset local state
         setFlattenedData([]);
         setSelectedRows({});
         setSelectedRowData([]);
         setLocalStyleUpdates({});
         setExpandedItems({});
         // Reset fetch tracking so next account selection fetches fresh
         initialLoadRef.current = false;
         previousParamsRef.current = {};
         // Abort any in-flight request
         if (abortControllerRef.current) {
            abortControllerRef.current.abort();
            abortControllerRef.current = null;
         }
      }
   }, [dispatch]);

   const handleSearchChange = (e) => {
      const value = e.target.value;
      setSearchInput(value);
      if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
      searchTimeoutRef.current = setTimeout(() => setSearchQuery(value), 600);
   };

   useEffect(() => {
      if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
      if (initialLoadRef.current) {
         searchTimeoutRef.current = setTimeout(() => fetchData(searchQuery), 600);
      }
      return () => { if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current); };
   }, [searchQuery, fetchData]);

   const handleRefresh = useCallback(() => {
      initialLoadRef.current = false;
      previousParamsRef.current = {};
      fetchData(searchQuery);
   }, [fetchData, searchQuery]);

   const toggleExpand = useCallback((id) => {
      setExpandedItems((prev) => ({ ...prev, [id]: !prev[id] }));
   }, []);

   const formatDateToDDMMYYYY = useCallback((dateString) => {
      if (!dateString) return '-';
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '-';
      return `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
   }, []);

   const handleRowSelection = useCallback((rowId, isChecked, row) => {
      setSelectedRows((prev) => {
         const n = { ...prev };
         if (isChecked) n[rowId] = true; else delete n[rowId];
         return n;
      });
      setSelectedRowData((prev) => {
         if (isChecked) {
            if (!prev.find((item) => item.rowId === rowId)) return [...prev, { rowId, ...row }];
            return prev;
         }
         return prev.filter((item) => item.rowId !== rowId);
      });
   }, []);

   const handleSelectAllAccount = useCallback((accId, accountData, isChecked) => {
      setSelectedRows((prev) => {
         const n = { ...prev };
         accountData.data.forEach((row, idx) => {
            const rId = `${accId}-${idx}`;
            if (isChecked) n[rId] = true; else delete n[rId];
         });
         return n;
      });
      setSelectedRowData((prev) => {
         if (isChecked) {
            const newRows = accountData.data.map((row, idx) => ({ rowId: `${accId}-${idx}`, ...row }));
            const existing = new Set(prev.map((item) => item.rowId));
            return [...prev, ...newRows.filter((r) => !existing.has(r.rowId))];
         }
         return prev.filter((item) => !item.rowId.startsWith(`${accId}-`));
      });
   }, []);

   // ── Filter handlers: set activeFilter (controls WHAT IS DISPLAYED) + select those rows ──
   const handleSelectAll = useCallback(() => {
      setActiveFilter('all');          // show all rows
      setFilterDropdownOpen(false);
      const allRows = getAllRows();
      const n = {};
      allRows.forEach(({ rowId }) => { n[rowId] = true; });
      setSelectedRows(n);
      setSelectedRowData(allRows.map(({ rowId, row }) => ({ rowId, ...row })));
      setIsAllSelected(true);
   }, [getAllRows]);

   const handleSelectChecked = useCallback(() => {
      setActiveFilter('checked');      // only show green rows
      setFilterDropdownOpen(false);
      const rows = getFilteredRows('checked');
      const n = {};
      rows.forEach(({ rowId }) => { n[rowId] = true; });
      setSelectedRows(n);
      setSelectedRowData(rows.map(({ rowId, row }) => ({ rowId, ...row })));
      setIsAllSelected(false);
   }, [getFilteredRows]);

   const handleSelectProblem = useCallback(() => {
      setActiveFilter('problem');      // only show red rows
      setFilterDropdownOpen(false);
      const rows = getFilteredRows('problem');
      const n = {};
      rows.forEach(({ rowId }) => { n[rowId] = true; });
      setSelectedRows(n);
      setSelectedRowData(rows.map(({ rowId, row }) => ({ rowId, ...row })));
      setIsAllSelected(false);
   }, [getFilteredRows]);

   const handleSelectUnchecked = useCallback(() => {
      setActiveFilter('unchecked');    // only show unchecked rows
      setFilterDropdownOpen(false);
      const rows = getFilteredRows('unchecked');
      const n = {};
      rows.forEach(({ rowId }) => { n[rowId] = true; });
      setSelectedRows(n);
      setSelectedRowData(rows.map(({ rowId, row }) => ({ rowId, ...row })));
      setIsAllSelected(false);
   }, [getFilteredRows]);

   const getFilteredAccountData = useCallback((accountData) => {
      if (activeFilter === 'all') return accountData;
      const filteredData = accountData.data.filter((row) => {
         switch (activeFilter) {
            case 'checked': return row.checkedStyle === 1;
            case 'problem': return row.checkedStyle === 2;
            case 'unchecked': return !row.checkedStyle || row.checkedStyle === 0;
            default: return true;
         }
      });
      return { ...accountData, data: filteredData };
   }, [activeFilter]);

   const batchUpdateCheckedStyle = useCallback(async (type) => {
      if (selectedRowData.length === 0) return;
      const checkedStyles = selectedRowData.map((row) => ({ entryType: row.DocType, entryId: row.docid, type }));
      const currentSelectedRows = [...selectedRowData];
      setSelectedRows({});
      setSelectedRowData([]);
      try {
         await dispatch(statementCheckedStyle({ checkedStyles }));
         await dispatch(getSatementReport({
            fromDate: dateRange.fromDate, toDate: dateRange.toDate,
            companyIds: validCompanyIds.join(','), accIds: accountId,
            orderBy: 'desc', search: searchQuery,
         }));
         setLocalStyleUpdates((prev) => {
            const updated = { ...prev };
            currentSelectedRows.forEach((row) => { updated[`${row.DocType}-${row.docid}`] = type; });
            return updated;
         });
         setTimeout(() => {
            fetchData(searchQuery);
            setTimeout(() => {
               setLocalStyleUpdates((prev) => {
                  const updated = { ...prev };
                  currentSelectedRows.forEach((row) => { delete updated[`${row.DocType}-${row.docid}`]; });
                  return updated;
               });
            }, 1000);
         }, 300);
      } catch (error) {
         console.error('Error:', error);
         fetchData(searchQuery);
      }
   }, [selectedRowData, dispatch, searchQuery, fetchData, dateRange, validCompanyIds, accountId]);

   const handleUnchecked = useCallback(() => batchUpdateCheckedStyle(0), [batchUpdateCheckedStyle]);
   const handleChecked = useCallback(() => batchUpdateCheckedStyle(1), [batchUpdateCheckedStyle]);
   const handleProblem = useCallback(() => batchUpdateCheckedStyle(2), [batchUpdateCheckedStyle]);

   useEffect(() => {
      const calculateHeight = () => {
         const windowHeight = window.innerHeight;
         setContainerHeight(Math.max(windowHeight - 250 - 15 - 32, 400));
      };
      calculateHeight();
      window.addEventListener('resize', calculateHeight);
      return () => window.removeEventListener('resize', calculateHeight);
   }, []);

   const flattenHierarchicalData = useCallback((processedLedger) => {
      if (!processedLedger || processedLedger.length === 0) return [];
      const flatItems = [];

      // Calculate GRAND TOTAL if multiple companies are selected
      if (companyFilter.length > 1) {
         let grandTotalDebit = 0;
         let grandTotalCredit = 0;
         let grandTotalBalance = 0;
         let totalTransactions = 0;

         processedLedger.forEach((company) => {
            company.accounts?.forEach((acc) => {
               // Add account totals
               acc.data?.forEach((row) => {
                  if (row.txnType === 1) grandTotalDebit += Math.abs(row.amount || 0);
                  if (row.txnType === 0) grandTotalCredit += Math.abs(row.amount || 0);
                  totalTransactions++;
               });
               // Use the last balance as closing balance for this account
               if (acc.data && acc.data.length > 0) {
                  grandTotalBalance += acc.data[0].bal || 0;
               }
            });
         });

         flatItems.push({
            type: 'grand-total',
            data: {
               totalDebit: grandTotalDebit,
               totalCredit: grandTotalCredit,
               totalBalance: grandTotalBalance,
               totalTransactions,
               companyCount: companyFilter.length,
            },
            id: 'grand-total-top',
            depth: 0,
         });
      }

      processedLedger.forEach((company, companyIndex) => {
         flatItems.push({
            type: 'company-header',
            data: company,
            id: `company-${company.companyId}`,
            companyId: company.companyId,
            companyIndex,
            depth: 0
         });

         if (expandedItems[`company-${company.companyId}`]) {
            company.accounts?.forEach((acc, accountIndex) => {
               flatItems.push({
                  type: 'account-header',
                  data: acc,
                  id: `account-${acc.accountId}`,
                  companyId: company.companyId,
                  accountId: acc.accountId,
                  accountIndex,
                  depth: 1
               });

               if (expandedItems[`account-${acc.accountId}`]) {
                  flatItems.push({
                     type: 'column-headers',
                     data: acc,
                     id: `headers-${acc.accountId}`,
                     companyId: company.companyId,
                     accountId: acc.accountId,
                     depth: 2
                  });

                  const filtered = getFilteredAccountData(acc);
                  filtered.data?.forEach((row, rowIndex) => {
                     flatItems.push({
                        type: 'data-row',
                        data: row,
                        id: `row-${acc.accountId}-${rowIndex}`,
                        companyId: company.companyId,
                        accountId: acc.accountId,
                        rowIndex,
                        rowId: `${acc.accountId}-${rowIndex}`,
                        depth: 2
                     });
                  });
               }
            });
         }
      });

      return flatItems;
   }, [expandedItems, getFilteredAccountData, companyFilter]);

   useEffect(() => {
      if (processedLedger.length > 0) {
         const flat = flattenHierarchicalData(processedLedger);
         setFlattenedData(flat);
         if (listRef.current) listRef.current.resetAfterIndex(0);
      }
   }, [processedLedger, expandedItems, flattenHierarchicalData]);

   const getItemSize = useCallback((index) => {
      const item = flattenedData[index];
      if (!item) return 55;
      switch (item.type) {
         case 'grand-total': return 55;
         case 'company-header': return 50;
         case 'account-header': return 40;
         case 'column-headers': return 40;
         case 'data-row': return 29;
         default: return 50;
      }
   }, [flattenedData]);

   // ── HEADER STYLES ─────────────────────────────────────────────────────────
   const headerBg = isDark ? '#0f172a' : '#f8fafc';
   const headerColor = isDark ? '#94a3b8' : '#475569';
   const headerBorder = isDark ? '#334155' : '#cbd5e1';

   const RowRenderer = useCallback(({ index, style }) => {
      const item = flattenedData[index];
      if (!item) return <div style={style} />;
      // ── Grand Total Row ────────────────────────────────────────────────────
      if (item.type === 'grand-total') {
         const totals = item.data;
         return (
            <div style={style}>
               <div
                  style={{
                     display: 'grid',
                     gridTemplateColumns: GRID_TEMPLATE,
                     alignItems: 'center',
                     height: '100%',
                     background: isDark
                        ? 'linear-gradient(90deg,#0b3b2c,#1e4b3a,#0b3b2c)'
                        : 'linear-gradient(90deg,#d1fae5,#a7f3d0,#d1fae5)',
                     borderLeft: `6px solid ${isDark ? '#10b981' : '#059669'}`,
                     borderTop: `2px solid ${isDark ? '#065f46' : '#10b981'}`,
                     borderBottom: `2px solid ${isDark ? '#065f46' : '#10b981'}`,
                     fontWeight: 700,
                     fontSize: '13px',
                  }}>

                  {/* GRAND TOTAL Label - spans 6 columns */}
                  <div style={{
                     gridColumn: '1 / 7',
                     display: 'flex',
                     alignItems: 'center',
                     gap: 12,
                     padding: '0 12px',
                     overflow: 'hidden'
                  }}>
                     <span style={{
                        fontWeight: 800,
                        fontSize: 14,
                        color: isDark ? '#d1fae5' : '#064e3b',
                        whiteSpace: 'nowrap'
                     }}>
                        GRAND TOTAL ({totals.companyCount} Companies)
                     </span>
                     <span style={{
                        padding: '2px 10px',
                        borderRadius: 12,
                        fontSize: 11,
                        fontWeight: 600,
                        background: isDark ? 'rgba(16,185,129,0.2)' : 'white',
                        color: isDark ? '#a7f3d0' : '#065f46',
                        border: `1px solid ${isDark ? '#10b981' : '#a7f3d0'}`,
                     }}>
                        {totals.totalTransactions} Transactions
                     </span>
                  </div>

                  {/* Debit Total - column 7 */}
                  <div style={{
                     ...cellRight,
                     fontWeight: 700,
                     fontSize: 13,
                     color: isDark ? '#34d399' : '#065f46',
                     whiteSpace: 'nowrap'
                  }}>
                     ₹{totals.totalDebit.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                  </div>

                  {/* Credit Total - column 8 */}
                  <div style={{
                     ...cellRight,
                     fontWeight: 700,
                     fontSize: 13,
                     color: isDark ? '#f87171' : '#991b1b',
                     whiteSpace: 'nowrap'
                  }}>
                     ₹{totals.totalCredit.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                  </div>

                  {/* Balance Total - column 9 */}
                  <div style={{
                     ...cellRight,
                     fontWeight: 700,
                     fontSize: 13,
                     color: isDark ? '#c7d2fe' : '#3730a3',
                     whiteSpace: 'nowrap',
                     gap: 4
                  }}>
                     ₹{Math.abs(totals.totalBalance).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                     <span style={{
                        fontSize: 10,
                        marginLeft: 2,
                        color: totals.totalBalance < 0
                           ? (isDark ? '#f87171' : '#b91c1c')
                           : (isDark ? '#34d399' : '#065f46')
                     }}>
                        {totals.totalBalance < 0 ? 'DB' : 'CR'}
                     </span>
                  </div>
               </div>
            </div>
         );
      }
      // ── Company Header ────────────────────────────────────────────────────
      if (item.type === 'company-header') {
         const company = item.data;
         return (
            <div style={style}>
               <div
                  onClick={() => toggleExpand(`company-${company.companyId}`)}
                  style={{
                     display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                     height: '100%', padding: '0 12px', cursor: 'pointer',
                     background: isDark
                        ? 'linear-gradient(90deg,#4c0519,#1c1917,#4c0519)'
                        : 'linear-gradient(90deg,#ffe4e6,#f5f5f4,#ffe4e6)',
                     borderLeft: `4px solid ${isDark ? '#f43f5e' : '#e11d48'}`,
                  }}>
                  <span style={{ fontWeight: 900, fontSize: 15, color: isDark ? '#ffe4e6' : '#881337' }}>
                     {company.companyName}
                  </span>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                     <span style={{
                        padding: '2px 10px', borderRadius: 8, fontSize: 12, fontWeight: 700,
                        background: isDark ? 'rgba(244,63,94,0.2)' : 'white',
                        color: isDark ? '#fda4af' : '#881337',
                        border: `1px solid ${isDark ? '#9f1239' : '#fda4af'}`,
                     }}>
                        {company.accounts?.length || 0} Account{company.accounts?.length !== 1 ? 's' : ''}
                     </span>
                     {expandedItems[`company-${company.companyId}`]
                        ? <ChevronUpIcon color={isDark ? '#f43f5e' : '#e11d48'} />
                        : <ChevronDownIcon color={isDark ? '#f43f5e' : '#e11d48'} />}
                  </div>
               </div>
            </div>
         );
      }

      // ── Account Header ────────────────────────────────────────────────────
      if (item.type === 'account-header') {
         const acc = item.data;
         const filtered = getFilteredAccountData(acc);
         const totalDebit = filtered.data.filter((r) => r.txnType === 1).reduce((s, r) => s + Math.abs(r.amount || 0), 0);
         const totalCredit = filtered.data.filter((r) => r.txnType === 0).reduce((s, r) => s + Math.abs(r.amount || 0), 0);
         const closingBal = filtered.data.length > 0 ? filtered.data[0].bal : acc.openingBalance;

         return (
            <div style={style}>
               {/* ── Account header also uses GRID_TEMPLATE so amounts align with column headers ── */}
               <div
                  onClick={() => toggleExpand(`account-${acc.accountId}`)}
                  style={{
                     display: 'grid',
                     gridTemplateColumns: GRID_TEMPLATE,
                     alignItems: 'center',
                     height: '100%',
                     cursor: 'pointer',
                     background: isDark
                        ? 'linear-gradient(90deg,#1e1b4b,#1e293b,#1e1b4b)'
                        : 'linear-gradient(90deg,#eff6ff,#eef2ff,#eff6ff)',
                     borderLeft: `4px solid ${isDark ? '#818cf8' : '#4f46e5'}`,
                  }}>
                  {/* Span first 6 columns for account name + opening balance */}
                  <div style={{ gridColumn: '1 / 7', display: 'flex', alignItems: 'center', gap: 10, padding: '0 10px', overflow: 'hidden' }}>
                     <span style={{ fontWeight: 700, fontSize: 13, color: isDark ? '#c7d2fe' : '#3730a3', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {acc.accountName}
                     </span>
                     <span style={{
                        whiteSpace: 'nowrap', fontSize: 11, fontWeight: 600, padding: '1px 8px', borderRadius: 999,
                        background: isDark ? 'rgba(129,140,248,0.2)' : 'white',
                        color: isDark ? '#a5b4fc' : '#4338ca',
                        border: `1px solid ${isDark ? '#4338ca' : '#c7d2fe'}`,
                     }}>
                        Opening: ₹{Math.abs(acc.openingBalance).toLocaleString('en-IN')}
                        {' '}<span style={{ color: acc.openingBalance >= 0 ? (isDark ? '#34d399' : '#065f46') : (isDark ? '#f87171' : '#991b1b') }}>
                           {acc.openingBalance >= 0 ? 'CR' : 'DB'}
                        </span>
                     </span>
                  </div>
                  {/* Debit total — column 7 */}
                  <div style={{ ...cellRight, fontWeight: 700, fontSize: 13, color: isDark ? '#34d399' : '#065f46', whiteSpace: 'nowrap' }}>
                     ₹{totalDebit.toLocaleString('en-IN')}
                  </div>
                  {/* Credit total — column 8 */}
                  <div style={{ ...cellRight, fontWeight: 700, fontSize: 13, color: isDark ? '#f87171' : '#991b1b', whiteSpace: 'nowrap' }}>
                     ₹{totalCredit.toLocaleString('en-IN')}
                  </div>
                  {/* Balance + chevron — column 9 */}
                  <div style={{ ...cellRight, fontWeight: 700, fontSize: 12, whiteSpace: 'nowrap', gap: 6 }}>
                     <span style={{ color: isDark ? '#c7d2fe' : '#3730a3' }}>
                        ₹{Math.abs(closingBal).toLocaleString('en-IN')}
                        {' '}<span style={{ fontSize: 10, color: closingBal < 0 ? (isDark ? '#f87171' : '#b91c1c') : (isDark ? '#34d399' : '#065f46') }}>
                           {closingBal < 0 ? 'DB' : 'CR'}
                        </span>
                     </span>
                     {expandedItems[`account-${acc.accountId}`]
                        ? <ChevronUpIcon color={isDark ? '#818cf8' : '#4f46e5'} />
                        : <ChevronDownIcon color={isDark ? '#818cf8' : '#4f46e5'} />}
                  </div>
               </div>
            </div>
         );
      }

      // ── Column Headers ────────────────────────────────────────────────────
      if (item.type === 'column-headers') {
         let columnAccountData = null;
         for (const company of processedLedger) {
            const acc = company.accounts?.find((a) => a.accountId === item.accountId);
            if (acc) { columnAccountData = getFilteredAccountData(acc); break; }
         }
         const allRowsSelected = columnAccountData?.data?.every((_, idx) => selectedRows[`${item.accountId}-${idx}`]) || false;

         return (
            <div style={style}>
               <div style={{
                  display: 'grid',
                  gridTemplateColumns: GRID_TEMPLATE,
                  alignItems: 'center',
                  height: '100%',
                  background: headerBg,
                  borderBottom: `2px solid ${headerBorder}`,
                  position: 'sticky',
                  top: 0,
                  zIndex: 1,
               }}>
                  {/* Checkbox + dropdown — React state driven, works in VariableSizeList */}
                  <div ref={dropdownRef} style={{ ...cellBase, justifyContent: 'center', position: 'relative' }}>
                     <Checkbox isChecked={allRowsSelected} onChange={(e) => { e.stopPropagation(); handleSelectAllAccount(item.accountId, columnAccountData, e.target.checked); }} colorScheme="blue" size="md" />
                     <div style={{ marginLeft: 2, position: 'relative' }}>
                        <button
                           onClick={(e) => { e.stopPropagation(); setFilterDropdownOpen((prev) => !prev); }}
                           style={{
                              background: filterDropdownOpen ? (isDark ? 'rgba(99,102,241,0.2)' : 'rgba(99,102,241,0.1)') : 'none',
                              border: filterDropdownOpen ? '1px solid #6366f1' : '1px solid transparent',
                              borderRadius: 4, cursor: 'pointer', padding: '2px 4px',
                              display: 'flex', alignItems: 'center', transition: 'all 0.15s',
                           }}>
                           <ChevronDownIcon
                              boxSize={3}
                              color={filterDropdownOpen ? '#6366f1' : headerColor}
                              style={{ transform: filterDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}
                           />
                        </button>
                        {/* Dropdown — controlled by React state, always works */}
                        {filterDropdownOpen && (
                           <div style={{
                              position: 'fixed',
                              marginTop: 4,
                              width: 190,
                              borderRadius: 10,
                              zIndex: 9999,
                              background: isDark ? '#1e293b' : 'white',
                              border: `1px solid ${isDark ? '#334155' : '#e2e8f0'}`,
                              boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
                              overflow: 'hidden',
                           }}>
                              {/* Active filter indicator */}
                              <div style={{
                                 padding: '6px 14px 4px',
                                 fontSize: 10, fontWeight: 700, letterSpacing: '0.08em',
                                 color: isDark ? '#64748b' : '#94a3b8',
                                 textTransform: 'uppercase',
                                 borderBottom: `1px solid ${isDark ? '#1e293b' : '#f1f5f9'}`,
                              }}>
                                 Filter rows
                              </div>
                              {[
                                 { label: 'All', color: '#94a3b8', key: 'all', count: statusCounts.all, handler: handleSelectAll },
                                 { label: 'Checked', color: '#22c55e', key: 'checked', count: statusCounts.checked, handler: handleSelectChecked },
                                 { label: 'Problem', color: '#ef4444', key: 'problem', count: statusCounts.problem, handler: handleSelectProblem },
                                 { label: 'Un-Checked', color: '#eab308', key: 'unchecked', count: statusCounts.unchecked, handler: handleSelectUnchecked },
                              ].map((opt) => (
                                 <button
                                    key={opt.key}
                                    onClick={(e) => { e.stopPropagation(); opt.handler(); }}
                                    disabled={opt.count === 0}
                                    style={{
                                       width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                       padding: '9px 14px', border: 'none',
                                       background: activeFilter === opt.key
                                          ? (isDark ? 'rgba(99,102,241,0.15)' : 'rgba(99,102,241,0.08)')
                                          : 'none',
                                       cursor: opt.count === 0 ? 'not-allowed' : 'pointer',
                                       opacity: opt.count === 0 ? 0.4 : 1,
                                       color: isDark ? 'white' : '#111',
                                       fontSize: 13,
                                       borderLeft: activeFilter === opt.key ? '3px solid #6366f1' : '3px solid transparent',
                                       transition: 'all 0.1s',
                                    }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                       <div style={{ width: 10, height: 10, borderRadius: '50%', background: opt.count === 0 ? '#94a3b8' : opt.color }} />
                                       <span style={{ fontWeight: activeFilter === opt.key ? 700 : 400 }}>{opt.label}</span>
                                    </div>
                                    <span style={{
                                       fontSize: 11, fontWeight: 600, minWidth: 22, textAlign: 'center',
                                       padding: '1px 6px', borderRadius: 999,
                                       background: isDark ? 'rgba(255,255,255,0.08)' : '#f1f5f9',
                                       color: isDark ? '#94a3b8' : '#64748b',
                                    }}>{opt.count}</span>
                                 </button>
                              ))}
                           </div>
                        )}
                     </div>
                  </div>

                  {[
                     { label: 'Date', align: 'left' },
                     { label: 'Doc#', align: 'left' },
                     { label: 'Daybook', align: 'left' },
                     { label: 'Contra Account', align: 'left' },
                     { label: 'Particulars', align: 'left' },
                     { label: 'Debit', align: 'right', color: isDark ? '#4ade80' : '#166534' },
                     { label: 'Credit', align: 'right', color: isDark ? '#f87171' : '#991b1b' },
                     { label: 'Balance', align: 'right', color: isDark ? '#818cf8' : '#3730a3' },
                  ].map((col, i) => (
                     <div key={i} style={{
                        ...(col.align === 'right' ? cellRight : cellBase),
                        fontWeight: 700, fontSize: 14,
                        color: col.color || headerColor,
                        whiteSpace: 'nowrap',
                     }}>
                        {col.label}
                     </div>
                  ))}
               </div>
            </div>
         );
      }

      // ── Data Row ──────────────────────────────────────────────────────────
      if (item.type === 'data-row') {
         const row = item.data;
         const accId = item.accountId;
         const rowId = item.rowId;
         const idx = item.rowIndex;

         const handledata = async (data, e) => {
            if (e.target.type === 'checkbox' || e.target.closest('input[type="checkbox"]') || e.target.closest('[role="checkbox"]')) {
               e.stopPropagation(); return;
            }
            try {
               const cId = parseInt(localStorage.getItem('companyId'));

               if (cId === data.companyid && data.daybooktype === 20 && (admin || rights?.inventoryreceive?.view)) {
                  setEntityType('receivemaster');
                  const response = await dispatch(getReceiveInventory(data.docid));
                  await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
                  setIsOpenSingleViewinr(true);
               }


               if (cId === data.companyid && data.daybooktype === 19 && (admin || rights?.inventoryissue?.view)) {
                  setEntityType('issuemaster');
                  const response = await dispatch(getIssueInventory(data.docid));
                  await dispatch(getAccountById({ id: response?.accountId, compId: user?.loginhistory?.companyId }));
                  setIsOpenSingleViewinr(true);
               }


               if (cId === data.companyid && data.daybooktype === 11 && (admin || rights?.purchaseinvoice?.view)) {

                  setEntityType('purchaseinvoice');

                  await dispatch(getPurchaseInvoice(data.docid));

                  setIsOpenPurchaseReturnSingleView(true);

               }


               if (cId === data.companyid && data.daybooktype === 5 && (admin || rights?.saleinvoice?.view)) {

                  setEntityType('saleinvoice');

                  await dispatch(getSaleInvoice(data.docid));

                  setIsOpenPurchaseReturnSingleView(true);

               }


               if (cId === data.companyid && data.daybooktype === 12 && (admin || rights?.purchasereturn?.view)) {
                  setEntityType('purchasereturn');
                  await dispatch(getSinglePurchaseReturn(data.docid));
                  await dispatch(getSinglePurchaseReturnWithPrevAndNext({ id: data.docid, page: 1, limit: 1, sortBy: 'id', sortOrder: 'desc' }));
                  setIsOpenPurchaseReturnSingleView(true);
               }


               if (cId === data.companyid && data.daybooktype === 6 && (admin || rights?.salereturn?.view)) {
                  setEntityType('salereturn');
                  await dispatch(getSingleSalesReturnWithPrevAndNext({ id: data.docid, page: 1, limit: 1, sortBy: 'id', sortOrder: 'desc' }));
                  setIsOpenPurchaseReturnSingleView(true);
               }


               if (cId === data.companyid && data.daybooktype === 13 && (admin || rights?.cashPayment?.view || rights?.cashReceive?.view)) {

                  setEntityType('cash');

                  setIsBankPageTrue(false);

                  await dispatch(getOneVoucher(data.docid));

                  setIsOpenSingleViewcnb(true);

               }


               if (cId === data.companyid && data.daybooktype === 14 && (admin || rights?.bankPayment?.view || rights?.bankReceive?.view)) {

                  setEntityType('bank');

                  setIsBankPageTrue(true);

                  await dispatch(getOneVoucher(data.docid));

                  setIsOpenSingleViewcnb(true);

               }


               if (cId === data.companyid && data.daybooktype === 18 && (admin || rights?.journalvouchers?.view)) {
                  setEntityTypesv('JV');
                  const response = await dispatch(getJournalVoucher({ docNumber: data.docnumber, companyId: user?.loginhistory?.companyId }));
                  setCurrentRow(response[0]);
                  setisOpenJV(true);
                  setIsEditMode(true);
               }

            } catch (error) {
               console.error('Error loading record:', error);
            } finally {
            }
         };

         return (
            <div style={style}>
               <MemoizedDataRow
                  row={row}
                  idx={idx}
                  rowId={rowId}
                  isSelected={selectedRows[rowId] || false}
                  onSelection={handleRowSelection}
                  onRowClick={handledata}
                  formatDateToDDMMYYYY={formatDateToDDMMYYYY}
                  iconColor={iconColor}
                  formatCellAmount={formatCellAmount}
                  localStyleUpdates={localStyleUpdates}
                  isDark={isDark}
               />
            </div>
         );
      }

      return <div style={style} />;
   }, [
      flattenedData, isDark, expandedItems, processedLedger, getFilteredAccountData,
      selectedRows, handleSelectAllAccount, statusCounts, handleSelectAll, handleSelectChecked,
      handleSelectProblem, handleSelectUnchecked, toggleExpand, dispatch, user, handleRowSelection,
      formatDateToDDMMYYYY, iconColor, formatCellAmount, localStyleUpdates, headerBg, headerColor,
      headerBorder, filterDropdownOpen, setFilterDropdownOpen, activeFilter,
   ]);

   // ── Style vars for Select ──────────────────────────────────────────────
   const selectedbgColor = useColorModeValue('#d2e0f4ff', '#1A365D');
   const focusedbgColor = useColorModeValue('#d2e0f4ff', '#2D3748');
   const optionbgColor = useColorModeValue('#ffffff', '#1A202C');
   const optionTextColor = useColorModeValue('#000000', '#ffffff');
   const bgcolor1 = useColorModeValue('#ffffff', '#1A202C');

   const selectStyles = useMemo(() => ({
      control: (b) => ({ ...b, minHeight: '30px', height: '30px' }),
      menu: (b) => ({ ...b, backgroundColor: bgcolor1 }),
      option: (b, { isFocused, isSelected }) => ({ ...b, backgroundColor: isSelected ? selectedbgColor : isFocused ? focusedbgColor : optionbgColor, color: optionTextColor, cursor: 'pointer', padding: '8px 12px' }),
      valueContainer: (b) => ({ ...b, height: '30px', padding: '0 6px' }),
      indicatorsContainer: (b) => ({ ...b, height: '30px' }),
   }), [bgcolor1, selectedbgColor, focusedbgColor, optionbgColor, optionTextColor]);

   const accountFilterOption = useCallback((option, searchInput) => {
      if (!searchInput) return true;
      const search = searchInput.trim().toLowerCase();
      const { label, value, gstRegNo, email, panNo, mobile, ownerName } = option.data;
      return (
         label.toLowerCase().includes(search) ||
         value.toString().toLowerCase().includes(search) ||
         (gstRegNo && gstRegNo.toString().toLowerCase().includes(search)) ||
         (email && email.toString().toLowerCase().includes(search)) ||
         (panNo && panNo.toString().toLowerCase().includes(search)) ||
         (mobile && mobile.toString().toLowerCase().includes(search)) ||
         (ownerName && ownerName.toString().toLowerCase().includes(search))
      );
   }, []);

   const startEditing = async (id, rowData) => {
      await dispatch(getDaybookForPayments({ type: isBankPageTrue ? 14 : 13, companyId: user?.loginhistory?.companyId, ...(shouldSendIdInDaybook && { companyIds: user?.loginhistory?.companyId }) }));
      const selectAcc = accountData.filter((acc) => acc.id === rowData.accountId);
      setSelectedEditAccount(selectAcc[0]);
      setFormData((prev) => ({ ...prev, id, ...rowData }));
      setIsOutstandingModalOpen(true);
      setUpdateFormLoading(true);
   };

   const handleClearData = () => {
      setPendingVoucher([]);
      setFormData({ companyId: parseInt(localStorage.getItem('companyId')), txnDate: new Date().toISOString().split('T')[0], daybookId: daybookTypeData?.length === 1 ? daybookTypeData[0].id : '', docNumber: 0, txnType: `${transactionType === 'payment' ? 1 : 0}`, accountId: null, amount: receivedAmount, brokerId: null, supplierId: 0, chequeNo: 0, transactionNo: 0, bankId: 0, bankBranchId: 0, particulars: '', depositeDate: '', clearingDate: '', tdsApplicable: false, tdsAccountId: 0, tdsLimit: 0, tdsRate: 0, tdsCess: 0, tdsSurcharge: 0, tdsAmount: 0, tdsCessAmount: 0, tdsSurchargeAmount: 0, tdsHCessAmount: 0, tdsInterestAmount: 0, tdsPenaltyAmount: 0, tdsOthersAmount: 0, notes1: '', notes2: '', notes3: '', notes4: '', notes5: '', userNote: '', taxableValue: '', GSTAmount: 0, stateOfSupply: 0, isRCM: false, GSTSubTxnType: 0, HSNSACId: 0, typeofSupply: 0, partyBillNo: 0, GSTTxnType: 0, outAdjustments: [] });
      setReceivedAmount(0);
      setTotalPendingAccount(0);
   };

   const handleSave = async () => { };

   const deletePurchaseReturn = () => {
      const selectedDaybook = daybookData.find((db) => db.id === viewDetail?.daybookId);
      if (entityType === 'purchasereturn') {
         if (selectedDaybook?.askPasswordOnDelete) { setDataId(viewDetail?.id); setIsModalOpen(true); }
         else deleteRecord(viewDetail?.id, deletePurchaseReturnInvoice, dispatch, user?.loginhistory?.companyId, userGlobalSettingsData);
      }
      if (entityType === 'salereturn') {
         if (selectedDaybook?.askPasswordOnDelete) { setDataId(viewDetail?.id); setIsModalOpen(true); }
         else deleteRecord(viewDetail?.id, deleteSaleReturnInvoice, dispatch, user?.loginhistory?.companyId, userGlobalSettingsData);
      }
      if (entityType === 'saleinvoice') {
         if (selectedDaybook?.askPasswordOnDelete) { setDataId({ id: viewDetail?.id, daybookId: viewDetail.daybookId, accountId: viewDetail.accountId }); setIsModalOpen(true); }
         else deleteRecordForSales(viewDetail?.id, viewDetail?.daybookId, viewDetail?.accountId, deleteSaleInvoice, dispatch, storedCompanyId, userGlobalSettingsData);
      }
      if (entityType === 'purchaseinvoice') {
         if (selectedDaybook?.askPasswordOnDelete) { setDataId({ id: viewDetail?.id, daybookId: viewDetail.daybookId, accountId: viewDetail.accountId }); setIsModalOpen(true); }
         else deleteRecordForSales(viewDetail?.id, viewDetail.daybookId, viewDetail.accountId, deletePurchaseInvoice, dispatch, user?.loginhistory?.companyId, userGlobalSettingsData);
      }
      setIsOpenPurchaseReturnSingleView(false);
   };

   const handleSalesDetailsClose = () => setIsOpenPurchaseReturnSingleView();

   useEffect(() => {
      if (account) {
         setDynamicUserDetails([
            { label: 'Bill To', value: account?.name || '-' },
            { label: 'Mobile', value: account?.mobile || '-' },
            { label: 'PAN', value: account?.panNo || '-' },
            { label: 'Billing Address', value: account?.address || '-' },
         ]);
      }
   }, [account]);

   const handleNextPage = () => console.log('Next');
   const handlePrevPage = () => console.log('Prev');

   const downloadExcel = () => {
      if (processedLedger.length > 0) {
         const colors = {
            companyHeader: 'F8FAFC', // Light blue for company headers (matches UI)
            itemHeader: 'F8FAFC', // Light gray for item headers
            oddRow: 'FFFFFF', // White for odd rows
            evenRow: 'F5F5F5', // Light gray for even rows
            totalRow: 'E6FFED', // Light rose for totals
            headerText: '000000', // Black for header text
         };

         const headers = ['Date', 'Doc', 'Daybook', 'ContraAccount', 'Particulars', 'Debit', 'Credit', 'Balance'];
         const finalData = [];
         const styles = [];

         processedLedger.forEach((ProfitLossdata) => {
            // finalData.push([`${ProfitLossdata.companyName}`]);
            const companyNameRow = Array(headers.length).fill('');
            companyNameRow[0] = ProfitLossdata.companyName;
            finalData.push(companyNameRow);
            styles.push(
               Array(headers.length).fill({
                  font: { bold: true, sz: 14, color: { rgb: colors.headerText } },
                  fill: { patternType: 'solid', fgColor: { rgb: 'F8FAFC' } },
                  alignment: { horizontal: 'left' },
               }),
            );

            ProfitLossdata.accounts.forEach((group) => {
               const totalcd = group.data
                  .filter((row) => row.txnType === 1)
                  .reduce((sum, row) => sum + Math.abs(row.amount || 0), 0)
                  .toLocaleString('en-IN'); // Optional: use 'en-IN' for Indian format like 1,23,456

               const totaldb = group.data
                  .filter((row) => row.txnType === 0)
                  .reduce((sum, row) => sum + Math.abs(row.amount || 0), 0)
                  .toLocaleString('en-IN'); // Optional: use 'en-IN' for Indian format like 1,23,456

               const totalbal = group.data.length > 0 ? Math.abs(group.data[0].bal) : Math.abs(group.openingBalance);

               finalData.push([
                  group.accountName + '   ' + 'OpeningBalanc :' + group.openingBalance,
                  '',
                  '',
                  '',
                  '',
                  totalcd,
                  totaldb,
                  totalbal,
               ]);
               styles.push(
                  Array(headers.length).fill({
                     font: { bold: true, sz: 10, color: { rgb: colors.headerText } },
                  }),
               );

               finalData.push(headers);
               styles.push(
                  Array(headers.length).fill({
                     font: { bold: true, sz: 12, color: { rgb: colors.headerText } },
                  }),
               );

               group.data.forEach((groupdata) => {
                  const row = [];
                  const rowStyle = [];
                  row.push(formatDateToDDMMYYYY(groupdata.date) || '');
                  const docno = groupdata.docnumber || groupdata.docno || '';
                  const prefix = groupdata.prefix || '';
                  const postFix = groupdata.postFix || groupdata.suffix || '';
                  row.push(docno ? `${prefix}${docno}${postFix}` : '');
                  row.push(groupdata.daybookname || '');
                  row.push(groupdata.finalcontraaccountname || '');
                  row.push(groupdata.particulars || '');
                  row.push(groupdata.txnType === 1 ? Math.abs(groupdata.amount) : '-');
                  row.push(groupdata.txnType === 0 ? Math.abs(groupdata.amount) : '-');
                  row.push(groupdata.bal ? Math.abs(groupdata.bal) : '');

                  finalData.push(row);
                  styles.push(rowStyle);
               });

               finalData.push([]);
               styles.push([]);
            });

            finalData.push([]);
            styles.push([]);
         });

         // Create worksheet and workbook
         const ws = XLSX.utils.aoa_to_sheet(finalData);

         // Set column widths
         ws['!cols'] = [
            { width: 40 },
            { width: 10 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
         ];

         // Apply styles to each cell
         styles.forEach((rowStyles, rowNum) => {
            rowStyles.forEach((style, colNum) => {
               if (style) {
                  const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: colNum });
                  if (!ws[cellAddress]) ws[cellAddress] = {};
                  ws[cellAddress].s = style;
               }
            });
         });

         const wb = XLSX.utils.book_new();
         XLSX.utils.book_append_sheet(wb, ws, 'Statement');
         XLSX.writeFile(wb, 'Statement.xlsx');
      } else {
      }
   };

   const downloadPDF = () => {
      if (processedLedger.length === 0) return;

      // Use A3 landscape for more horizontal space
      const doc = new jsPDF({
         orientation: 'landscape',
         unit: 'mm',
         format: 'a3',
      });

      const colors = {
         headerBg: '#1e293b',       // Dark slate for main header
         headerText: '#f8fafc',
         subHeaderBg: '#f1f5f9',    // Light blue-gray for column headers
         subHeaderText: '#475569',
         accountBg: '#e2e8f0',
         accountText: '#0f172a',
         rowEven: '#ffffff',
         rowOdd: '#f8fafc',
         debitText: '#dc2626',      // Red for debit
         creditText: '#16a34a',     // Green for credit
         balanceText: '#1d4ed8',    // Blue for balance
         borderColor: '#cbd5e1',
         textPrimary: '#0f172a',
         textMuted: '#64748b',
         accent: '#2563eb',
         divider: '#94a3b8',
      };

      doc.setFont('helvetica');

      const margin = 12;
      const pageWidth = 420;   // A3 landscape width in mm
      const pageHeight = 297;  // A3 landscape height in mm
      const contentWidth = pageWidth - margin * 2;
      let yPos = margin;

      // ─── Column layout (mm from left margin) ───────────────────────────
      // Total content width ~396mm. Distribute proportionally.
      const colWidths = {
         date: 28,
         docNo: 22,
         daybook: 45,
         contra: 70,
         particulars: 80,
         debit: 40,
         credit: 40,
         balance: 46,
      };

      const colX = {
         date: margin,
         docNo: margin + colWidths.date,
         daybook: margin + colWidths.date + colWidths.docNo,
         contra: margin + colWidths.date + colWidths.docNo + colWidths.daybook,
         particulars: margin + colWidths.date + colWidths.docNo + colWidths.daybook + colWidths.contra,
         debit: margin + colWidths.date + colWidths.docNo + colWidths.daybook + colWidths.contra + colWidths.particulars,
         credit: margin + colWidths.date + colWidths.docNo + colWidths.daybook + colWidths.contra + colWidths.particulars + colWidths.debit,
         balance: margin + colWidths.date + colWidths.docNo + colWidths.daybook + colWidths.contra + colWidths.particulars + colWidths.debit + colWidths.credit,
      };

      // ─── Helpers ───────────────────────────────────────────────────────

      const checkPageBreak = (neededHeight = 10) => {
         if (yPos + neededHeight > pageHeight - margin) {
            doc.addPage();
            yPos = margin;
            return true;
         }
         return false;
      };

      // Wrap text within a given width, return lines array
      const wrap = (text, width, fontSize) => {
         doc.setFontSize(fontSize);
         if (!text || text === '-') return ['-'];
         return doc.splitTextToSize(String(text), width - 2); // 2mm padding
      };

      // Draw a filled rectangle
      const fillRect = (x, y, w, h, color) => {
         doc.setFillColor(color);
         doc.rect(x, y, w, h, 'F');
      };

      // Draw a border line
      const hLine = (y, x1 = margin, x2 = pageWidth - margin, width = 0.2, color = colors.borderColor) => {
         doc.setDrawColor(color);
         doc.setLineWidth(width);
         doc.line(x1, y, x2, y);
      };

      // ─── Company Header ────────────────────────────────────────────────
      const addCompanyHeader = (companyName) => {
         checkPageBreak(20);
         const h = 12;
         fillRect(margin, yPos, contentWidth, h, colors.headerBg);
         doc.setTextColor(colors.headerText);
         doc.setFontSize(13);
         doc.setFont('helvetica', 'bold');
         doc.text(companyName.toUpperCase(), margin + 4, yPos + 8);
         yPos += h + 3;
      };

      // ─── Account Header ────────────────────────────────────────────────
      const addAccountHeader = (account) => {
         checkPageBreak(24);

         const totalDebit = account.data
            .filter(r => r.txnType === 1)
            .reduce((s, r) => s + Math.abs(r.amount || 0), 0);
         const totalCredit = account.data
            .filter(r => r.txnType === 0)
            .reduce((s, r) => s + Math.abs(r.amount || 0), 0);
         const closingBalance = account.data.length > 0
            ? account.data[0].bal
            : account.openingBalance;

         const h = 16;
         fillRect(margin, yPos, contentWidth, h, colors.accountBg);
         hLine(yPos, margin, pageWidth - margin, 0.5, colors.divider);
         hLine(yPos + h, margin, pageWidth - margin, 0.5, colors.divider);

         // Account name
         doc.setTextColor(colors.accountText);
         doc.setFontSize(10.5);
         doc.setFont('helvetica', 'bold');
         doc.text(account.accountName, margin + 3, yPos + 6);

         // Opening balance
         doc.setFontSize(8.5);
         doc.setFont('helvetica', 'normal');
         doc.setTextColor(colors.textMuted);
         const ob = `Opening: ${Math.abs(account.openingBalance).toLocaleString('en-IN', { minimumFractionDigits: 2 })} ${account.openingBalance >= 0 ? 'CR' : 'DB'}`;
         doc.text(ob, margin + 3, yPos + 12.5);

         // Summary on right
         const summaryY1 = yPos + 6;
         const summaryY2 = yPos + 12.5;
         const rightEdge = pageWidth - margin - 3;

         doc.setTextColor(colors.accountText);
         doc.setFont('helvetica', 'bold');
         doc.text(`Dr: ${totalDebit.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`, rightEdge - 110, summaryY1, { align: 'right' });

         doc.setTextColor(colors.accountText);
         doc.text(`Cr: ${totalCredit.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`, rightEdge - 55, summaryY1, { align: 'right' });

         doc.setTextColor(colors.accountText);
         doc.setFontSize(9.5);
         doc.text(
            `Balance: ${Math.abs(closingBalance).toLocaleString('en-IN', { minimumFractionDigits: 2 })} ${closingBalance < 0 ? 'DB' : 'CR'}`,
            rightEdge, summaryY1, { align: 'right' }
         );

         // Txn count
         doc.setTextColor(colors.textMuted);
         doc.setFontSize(8);
         doc.setFont('helvetica', 'normal');
         doc.text(`${account.data.length} transactions`, rightEdge, summaryY2, { align: 'right' });

         yPos += h + 2;
      };

      // ─── Column Headers ────────────────────────────────────────────────
      const addColumnHeaders = () => {
         checkPageBreak(10);
         const h = 8;
         fillRect(margin, yPos, contentWidth, h, colors.subHeaderBg);
         hLine(yPos + h, margin, pageWidth - margin, 0.3, colors.borderColor);

         doc.setTextColor(colors.subHeaderText);
         doc.setFontSize(8);
         doc.setFont('helvetica', 'bold');

         const cy = yPos + 5.5;
         doc.text('Date', colX.date + 1, cy);
         doc.text('Doc #', colX.docNo + 1, cy);
         doc.text('Daybook', colX.daybook + 1, cy);
         doc.text('Contra Account', colX.contra + 1, cy);
         doc.text('Particulars', colX.particulars + 1, cy);
         doc.text('Debit', colX.debit + colWidths.debit - 1, cy, { align: 'right' });
         doc.text('Credit', colX.credit + colWidths.credit - 1, cy, { align: 'right' });
         doc.text('Balance', colX.balance + colWidths.balance - 1, cy, { align: 'right' });

         yPos += h + 1;
      };

      // ─── Transaction Row ───────────────────────────────────────────────
      const addTransactionRow = (row, index) => {
         const fontSize = 8;

         // Pre-calculate all wrapped text to determine row height
         const dateStr = row.date
            ? new Date(row.date).toLocaleDateString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '-')
            : '-';

         const lDate = wrap(dateStr, colWidths.date, fontSize);
         const docno = row.docnumber || row.docno || '';
         const prefix = row.prefix || '';
         const postFix = row.postFix || row.suffix || '';
         const fullDocNo = docno ? `${prefix}${docno}${postFix}` : '-';
         const lDocNo = wrap(fullDocNo, colWidths.docNo, fontSize);
         const lDaybook = wrap(row.daybookname, colWidths.daybook, fontSize);
         const lContra = wrap(row.finalcontraaccountname, colWidths.contra, fontSize);
         const lPart = wrap(row.particulars, colWidths.particulars, fontSize);

         const lineH = 4;
         const padV = 3;
         const maxLines = Math.max(lDate.length, lDocNo.length, lDaybook.length, lContra.length, lPart.length, 1);
         const rowH = maxLines * lineH + padV * 2;

         checkPageBreak(rowH + 2);

         // Alternating row background
         fillRect(margin, yPos, contentWidth, rowH, index % 2 === 0 ? colors.rowEven : colors.rowOdd);

         // Subtle bottom border
         hLine(yPos + rowH, margin, pageWidth - margin, 0.15, colors.borderColor);

         const textY = yPos + padV + lineH - 1;
         doc.setFont('helvetica', 'normal');
         doc.setFontSize(fontSize);

         // ── Text columns ──
         doc.setTextColor(colors.textMuted);
         lDate.forEach((line, i) => doc.text(line, colX.date + 1, textY + i * lineH));

         doc.setTextColor(colors.textPrimary);
         lDocNo.forEach((line, i) => doc.text(line, colX.docNo + 1, textY + i * lineH));
         lDaybook.forEach((line, i) => doc.text(line, colX.daybook + 1, textY + i * lineH));
         lContra.forEach((line, i) => doc.text(line, colX.contra + 1, textY + i * lineH));
         lPart.forEach((line, i) => doc.text(line, colX.particulars + 1, textY + i * lineH));

         // ── Numeric columns (right-aligned, first line only) ──
         const numY = textY;

         if (row.txnType === 1) {
            doc.setTextColor(colors.textPrimary);
            doc.setFont('helvetica', 'normal');
            doc.text(
               Math.abs(row.amount).toLocaleString('en-IN', { minimumFractionDigits: 2 }),
               colX.debit + colWidths.debit - 1, numY, { align: 'right' }
            );
         } else {
            doc.setTextColor(colors.textMuted);
            doc.setFont('helvetica', 'normal');
            doc.text('—', colX.debit + colWidths.debit - 1, numY, { align: 'right' });
         }

         if (row.txnType === 0) {
            doc.setTextColor(colors.textPrimary);
            doc.setFont('helvetica', 'normal');
            doc.text(
               Math.abs(row.amount).toLocaleString('en-IN', { minimumFractionDigits: 2 }),
               colX.credit + colWidths.credit - 1, numY, { align: 'right' }
            );
         } else {
            doc.setTextColor(colors.textMuted);
            doc.setFont('helvetica', 'normal');
            doc.text('—', colX.credit + colWidths.credit - 1, numY, { align: 'right' });
         }

         // Balance
         doc.setTextColor(colors.textPrimary);
         doc.setFont('helvetica', 'normal');
         doc.text(
            `${Math.abs(row.bal).toLocaleString('en-IN', { minimumFractionDigits: 2 })} ${row.bal < 0 ? 'DB' : 'CR'}`,
            colX.balance + colWidths.balance - 1, numY, { align: 'right' }
         );

         yPos += rowH;
      };

      // ─── Main Generation ───────────────────────────────────────────────
      processedLedger.forEach((company) => {
         addCompanyHeader(company.companyName);

         company.accounts.forEach((account) => {
            addAccountHeader(account);
            addColumnHeaders();

            // Sort newest first
            const sortedData = [...account.data].sort((a, b) => new Date(b.date) - new Date(a.date));
            sortedData.forEach((row, index) => addTransactionRow(row, index));

            // Account separator
            yPos += 3;
            hLine(yPos, margin, pageWidth - margin, 0.4, colors.divider);
            yPos += 6;
         });
      });

      // ─── Page Numbers ──────────────────────────────────────────────────
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
         doc.setPage(i);
         doc.setTextColor(colors.textMuted);
         doc.setFontSize(7.5);
         doc.setFont('helvetica', 'normal');
         doc.text(
            `Ledger Statement  ·  Generated ${new Date().toLocaleDateString('en-IN')}  ·  Page ${i} of ${pageCount}`,
            pageWidth / 2,
            pageHeight - 5,
            { align: 'center' }
         );
      }

      doc.save(`Ledger_Statement_${new Date().toISOString().split('T')[0]}.pdf`);
   };

   return (
      <>
         {/* Header */}
         <Flex px={{ base: '15px', md: '25px' }} mb="5px" justifyContent="space-between" align="center"
            mt={{ base: '80px', md: '40px' }} overflow="hidden" py={2}
            flexDirection={{ base: 'column', lg: 'row' }} gap={{ base: 3, lg: 0 }}>
            <Flex mb={{ base: 2, lg: 0 }}>
               <img src={back} alt="Go Back" width="15px" onClick={() => window.history.back()} style={{ cursor: 'pointer' }} />
               <Text color={textColor} fontSize={{ base: '13px', md: '15px' }} fontWeight="700" lineHeight="100%" ml={5}>
                  Statement Detail
               </Text>
            </Flex>
            <div className="flex flex-col sm:flex-row gap-2 w-full lg:w-auto">
               {[
                  { label: 'Un-Checked', handler: handleUnchecked, from: 'yellow-400', to: 'yellow-500', ring: 'yellow-300', icon: 'M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z' },
                  { label: 'Checked', handler: handleChecked, from: 'green-400', to: 'emerald-500', ring: 'green-300', icon: 'M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z' },
                  { label: 'Problem', handler: handleProblem, from: 'red-500', to: 'rose-600', ring: 'red-300', icon: 'M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z' },
               ].map((btn) => (
                  <button key={btn.label} onClick={btn.handler} disabled={selectedRowData.length === 0}
                     className={`px-4 sm:px-6 py-2 bg-gradient-to-r from-${btn.from} to-${btn.to} hover:from-${btn.to} text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 flex items-center justify-center space-x-2 focus:outline-none focus:ring-4 focus:ring-${btn.ring} text-sm sm:text-base ${selectedRowData.length === 0 ? 'opacity-50 cursor-not-allowed' : ''}`}>
                     <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 sm:h-5 sm:w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d={btn.icon} clipRule="evenodd" />
                     </svg>
                     <span>{btn.label} ({selectedRowData.length})</span>
                  </button>
               ))}
            </div>
         </Flex>

         {/* Filters */}
         <Box mt="15px" bg={backgroundColor} px={4} py={0} borderRadius="7px">
            <Flex className="flex flex-wrap gap-2" alignItems="center" justifyContent="end">
               <Flex flex="" gap={2} mr={3} display={{ base: 'none', xl: 'block' }}>
                  <Box my={2} width="300px" fontSize="13px" fontWeight={500} display={{ base: 'none', lg: 'block' }}>
                     <GridItem className="seperator-width" w="100%" mt={5}>
                        {renderDynamicDropdown('company', 'Company', lastcompanyOptions, { value: companyFilter, onChange: handleCompanyChange }, {}, textColor, false, 'Select company', true, undefined, true)}
                     </GridItem>
                  </Box>
               </Flex>
               <Flex flex="" gap={2} mr={3} zIndex={3} display={{ base: 'none', xl: 'block' }}>
                  <Box my={2} width="300px" fontSize="13px" fontWeight={500}>
                     <label>Account</label>
                     <Select placeholder="Select Account" name="accountId" options={accountOptions} onChange={handleAccountChange} value={accountOptions.find((o) => o.value === accountId)} isMulti={false} isClearable className="basic-multi-select" classNamePrefix="select" filterOption={accountFilterOption} styles={selectStyles} />
                  </Box>
               </Flex>
               <Flex flex="2" display={{ base: 'none', xl: 'flex' }}>
                  <Flex alignItems="center" mt={3}>
                     <PeriodDatePicker
                        value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                        onChange={handleDateRangeChange}
                        defaultPeriod="thisFinancialYear"
                        style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                     />
                  </Flex>
               </Flex>
               <Flex className="flex flex-wrap gap-2">
                  <Box flex="1" mr={3}>
                     <MotionFlex ref={wrapperRef} align="center" bg={bg} borderRadius="full" cursor="pointer" px={expanded ? 3 : 0} w={expanded ? '250px' : '40px'} h="40px" transition="all 0.3s ease" onClick={() => setExpanded(true)} overflow="hidden">
                        <MotionSearchIcon color={iconColor} animate={{ rotate: expanded ? 0 : 90 }} transition={{ duration: 0.3 }} style={{ marginRight: expanded ? '8px' : '0', marginLeft: expanded ? '0' : '10px' }} />
                        {expanded && <InputGroup width="200px"><Input placeholder="Search..." value={searchInput} onChange={handleSearchChange} color={iconColor} variant="unstyled" _placeholder={{ color: 'gray.400' }} /></InputGroup>}
                     </MotionFlex>
                  </Box>
                  <button onClick={handleRefresh} className={`h-[40px] px-4 rounded-lg transition-all duration-200 flex items-center gap-2 mr-2 ${isDark ? 'bg-blue-900/50 hover:bg-blue-800 text-blue-200 border-2 border-blue-700' : 'bg-blue-50 hover:bg-blue-100 text-blue-700 border-2 border-blue-200 shadow-md'}`}>
                     <LuRefreshCcw size={20} />
                  </button>
                  <button onClick={onFilterOpen} className={`h-[40px] px-4 rounded-lg transition-all duration-200 flex items-center gap-2 mr-2 ${isDark ? 'bg-purple-900/50 hover:bg-purple-800 text-purple-200 border-2 border-purple-700' : 'bg-purple-50 hover:bg-purple-100 text-purple-700 border-2 border-purple-200 shadow-md'}`}>
                     <IoFilterOutline size={22} />
                  </button>
                  <Popover>
                     <PopoverTrigger><img src={Download} alt="Download" width="30" style={{ cursor: 'pointer' }} /></PopoverTrigger>
                     <PopoverContent width="220px" zIndex="10" bg={backgroundColor} mr={8}>
                        <PopoverBody p="3">
                           <Button width="100%" variant="ghost" _hover={{ bg: 'blue.100' }} onClick={downloadExcel} justifyContent="space-between" mb={3}>
                              <img src={xls} alt="XLS" width="30px" /> Download Excel
                           </Button>
                           <Button width="100%" variant="ghost" _hover={{ bg: 'blue.100' }} onClick={downloadPDF} justifyContent="space-between">
                              <img src={json} alt="PDF" width="30px" /> Download PDF
                           </Button>
                        </PopoverBody>
                     </PopoverContent>
                  </Popover>
               </Flex>
               <Box ml={1}>
                  <Flex display={{ base: 'block', xl: 'none' }}>
                     <Button variant="unstyled" onClick={onOpen}><Image src={DotIcon} alt="Menu" width="25px" /></Button>
                  </Flex>
               </Box>

               <Drawer isOpen={isOpen} placement="bottom" onClose={onClose}>
                  <DrawerOverlay />
                  <DrawerContent borderTopRadius="20px">
                     <DrawerCloseButton />
                     <DrawerHeader borderBottomWidth="1px">Filters</DrawerHeader>
                     <DrawerBody>
                        <GridItem className="seperator-width">
                           {renderDynamicDropdown('company', 'Company', lastcompanyOptions, { value: companyFilter, onChange: handleCompanyChange }, {}, textColor, false, 'Select company', true, undefined, true)}
                        </GridItem>
                        <Box my={2} width="100%" fontSize="13px" fontWeight={500}>
                           <label>Account</label>
                           <Select placeholder="Select Account" name="accountId" options={accountOptions} onChange={handleAccountChange} value={accountOptions.find((o) => o.value === accountId)} isMulti={false} isClearable className="basic-multi-select" classNamePrefix="select" filterOption={accountFilterOption} styles={selectStyles} />
                        </Box>
                        <Box alignItems="center" mt={5}>
                           <PeriodDatePicker
                              value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                              onChange={handleDateRangeChange}
                              defaultPeriod="thisFinancialYear"
                              style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                           />
                        </Box>
                        <Button colorScheme="rose" width="100%" onClick={onClose} mt={4}>Apply Filters</Button>
                     </DrawerBody>
                  </DrawerContent>
               </Drawer>
            </Flex>
         </Box>

         {/* ── TABLE ── */}
         <Grid overflow="auto">
            <Card mt="15px" borderRadius="7px">
               <Box overflowX="auto" className="custom-scrollbar" position="relative"
                  minH={{ base: '75vh', md: '75vh', xl: '75vh' }}
                  maxH={{ base: '75vh', md: '75vh', xl: '75vh' }}
                  width="100%" height={`${containerHeight}px`} id="ledger-container">

                  {isFilterLoading && (
                     <Box
                        position="fixed"
                        top={0} left={0} right={0} bottom={0}
                        zIndex={9999}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        bg={isDark ? 'rgba(10,20,50,0.60)' : 'rgba(255,255,255,0.60)'}
                        backdropFilter="blur(3px)"
                     >
                        <Flex direction="column" align="center" gap={3}>
                           <Loader />
                        </Flex>
                     </Box>
                  )}

                  {isLoading ? (
                     <Loader />
                  ) : !accountId ? (
                     <Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="center">
                        <Flex direction="column" align="center" justify="center" gap={3}>
                           <Box
                              style={{
                                 width: 80, height: 80, borderRadius: '50%',
                                 background: isDark ? 'rgba(99,102,241,0.15)' : 'rgba(99,102,241,0.1)',
                                 display: 'flex', alignItems: 'center', justifyContent: 'center',
                                 fontSize: 36,
                              }}>
                              📋
                           </Box>
                           <Text fontSize="16px" fontWeight={700} color={isDark ? '#a5b4fc' : '#4338ca'}>
                              Please select an Account
                           </Text>
                           <Text fontSize="13px" color={isDark ? '#64748b' : '#94a3b8'}>
                              Choose an account from the dropdown above to view its statement
                           </Text>
                        </Flex>
                     </Box>
                  ) : flattenedData.length === 0 ? (
                     <Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="center">
                        <Flex direction="column" align="center" justify="center">
                           <img src={nodata} alt="No Data Found" width="200px" height="200px" />
                           <Text mt={4}>No ledger data found for selected account</Text>
                        </Flex>
                     </Box>
                  ) : (
                     <div style={{ minWidth: 900 }}>
                        <VariableSizeList
                           ref={listRef}
                           height={containerHeight}
                           width="100%"
                           itemCount={flattenedData.length}
                           itemSize={getItemSize}
                           overscanCount={15}
                           estimatedItemSize={55}>
                           {RowRenderer}
                        </VariableSizeList>
                     </div>
                  )}
               </Box>
            </Card>
         </Grid>

         <StatementFilter isOpen={isFilterOpen} onClose={onFilterClose} companyIds={companyIds} fromDate={dateRange.fromDate} toDate={dateRange.toDate} accountId={accountId} entityType="statement" onApply={() => setIsFilterLoading(true)} />

         {isOpenPurchaseReturnSingleView && (
            <div className="fixed inset-0 z-[999]">
               {isModalLoading ? (
                  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]"><Loader /></div>
               ) : viewDetail ? (
                  <SalesDetails isOpen={isOpenPurchaseReturnSingleView} onClose={handleSalesDetailsClose}
                     singleEntityRights={saleInvoiceRight || saleReturnRight || purchaseInvoiceRight || purchaseReturnRight}
                     title={entityType === 'saleinvoice' ? 'Sales Invoice' : entityType === 'salereturn' ? 'Sales Return' : entityType === 'purchaseinvoice' ? 'Purchase Invoice' : 'Purchase Return'}
                     entityType={entityType} singleEntity={viewDetail} handlePrevPage={handlePrevPage} handleNextPage={handleNextPage}
                     setIsEditFormOpen={setIsEditFormOpen} setIsOpenSingleView={setIsOpenPurchaseReturnSingleView}
                     isEditFormOpen={isEditFormOpen} viewDetail={viewDetail} lineItems={viewDetail?.lineitems}
                     billTerms={viewDetail?.purchasereturnbillteams} onDelete={deletePurchaseReturn}
                     handleSerchClose={() => { }} />
               ) : (
                  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]"><Loader /></div>
               )}
            </div>
         )}

         {updateFormLoading && formData.id && (
            <PaymentcaseFormEdit isOutstandingModalOpen={isOutstandingModalOpen} setIsOutstandingModalOpen={setIsOutstandingModalOpen} daybookTypeData={daybookTypeData} validationSchema={validationSchema} errors={errors} setErrors={setErrors} isBankPageTrue={isBankPageTrue} selectedAccount={selectedEditAccount} setSelectedAccount={setSelectedEditAccount} userData={accountData} type={13} isEditMode={true} receivedAmount={receivedAmount} setReceivedAmount={setReceivedAmount} totalPendingAccount={totalPendingAccount} setTotalPendingAccount={setTotalPendingAccount} formData={formData} setFormData={setFormData} transactionType={transactionType} handleClearData={handleClearData} pendingVoucher={pendingVoucher} setPendingVoucher={setPendingVoucher} currentPage={1} limit={10} companyId={companyId} sorting={sorting} pagination={10} />
         )}

         {isOpenSingleViewcnb && (
            <div className="fixed inset-0 z-[999]">
               {isModalLoading ? (
                  <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[9999]"><Loader /></div>
               ) : singleEntity ? (
                  <ViewSingleCashBankData isOpenSingleView={isOpenSingleViewcnb} onClose={() => setIsOpenSingleViewcnb(false)} singleEntity={singleEntity} formType="voucher" isBankPageTrue={isBankPageTrue} UserRights={(cashPaymentRight && cashReceiveRight) || (bankPaymentRight && bankReceiveRight)} paymentRight={cashPaymentRight || bankPaymentRight} receiveRight={cashReceiveRight || bankReceiveRight} startEditing={(data) => startEditing(data.id, data)} />
               ) : (
                  <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[9999]"><Loader /></div>
               )}
            </div>
         )}

         <JournalVoucherForm isOpen={isOpenJV} onClose={() => setisOpenJV(false)} isEditMode={isEditMode} currentRow={currentRow} onSave={handleSave} />

         <DeletePasswordModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}
            onConfirm={entityType === 'saleinvoice' || entityType === 'purchaseinvoice' ? deleteRecordForSales : deleteRecord}
            id={dataId}
            deleteApi={entityType === 'saleinvoice' ? deleteSaleInvoice : entityType === 'purchaseinvoice' ? deletePurchaseInvoice : entityType === 'salereturn' ? deleteSaleReturnInvoice : deletePurchaseReturnInvoice}
            dispatch={dispatch}
            type={entityType === 'saleinvoice' || entityType === 'purchaseinvoice' ? 'purchase' : 'receive'}
            userGlobalSettingsData={userGlobalSettingsData} />
      </>
   );
};

export default Ledger;